import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import systemReducer from './slices/systemSlice'; // ✅ import from systemSlice

export const store = configureStore({
  reducer: {
    auth: authReducer,
    system: systemReducer, // ✅ key matches selector in Layout
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;